import styled from "@emotion/styled";

export const SectionTitle = styled.h4`
	font-weight: 700;
	font-size: 20px;
	line-height: 120%;

	@media (max-width: 880px) {
		font-size: 18px;
	}
`;
